import axiosInstance from '../api/axiosInstance';
import { SGLOrder } from '../types/comparative';

export class ComparativeService {
  /**
   * Obtener pedidos de SGL filtrados por tienda
   * Reutiliza el mismo endpoint que OrdersTable
   */
  static async getSGLOrders(params: {
    stores: string[];
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    order?: 'asc' | 'desc';
    startDate?: string;
    endDate?: string;
  }): Promise<{
    data: SGLOrder[];
    meta: {
      currentPage: number;
      totalPages: number;
      totalItems: number;
    };
  }> {
    try {
      const token = localStorage.getItem('accessToken');
      const queryParams = new URLSearchParams();
      
      // Construir parámetros de query
      if (params.page) queryParams.append('page', params.page.toString());
      if (params.limit) queryParams.append('limit', params.limit.toString());
      if (params.search) queryParams.append('search', params.search);
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.order) queryParams.append('order', params.order);
      
      // Solo agregar stores si no es OFIMA
      const isOFIMA = params.stores.includes('OFIMA');
      if (params.stores.length > 0 && !isOFIMA) {
        queryParams.append('stores', params.stores.join(','));
      }
      
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);

      const response = await axiosInstance.get(
        `/list?${queryParams.toString()}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 30000
        }
      );

      const { data, meta } = response.data;
      
      return {
        data: data.map((order: SGLOrder, index: number) => ({
          ...order,
          customer_full_name: `${order.first_name ?? ''} ${order.last_name ?? ''}`,
          // Mantener la fecha original sin formatear para que funcione correctamente en la tabla
          date_created: order.date_created,
        })),
        meta: {
          currentPage: meta.currentPage,
          totalPages: meta.totalPages,
          totalItems: meta.totalItems,
        }
      };
    } catch (error) {
      console.error('Error fetching SGL orders:', error);
      throw new Error(`Error al obtener pedidos de SGL: ${error}`);
    }
  }

  /**
   * Buscar pedido específico en SGL por ID o número de pedido
   */
  static async findSGLOrderById(orderId: string, store: string): Promise<SGLOrder | null> {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance.get(
        `/list?search=${orderId}&stores=${store}&limit=1`,
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 30000
        }
      );

      const { data } = response.data;
      return data.length > 0 ? data[0] : null;
    } catch (error) {
      console.error('Error finding SGL order:', error);
      return null;
    }
  }

  /**
   * Obtener estadísticas de SGL por tienda
   */
  static async getSGLStatistics(store: string): Promise<any> {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance.get(
        `/list?stores=${store}&limit=1`,
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 30000
        }
      );

      return response.data.meta.statistics;
    } catch (error) {
      console.error('Error fetching SGL statistics:', error);
      throw new Error(`Error al obtener estadísticas de SGL: ${error}`);
    }
  }
}
